<template>
  <div>
    <Tabs value="name1">
      <TabPane label="会员管理" name="name1">
        <vip :vipData="vipData" :userId="userId" @afterSave="queryUserVipInfo"></vip>
      </TabPane>
      <TabPane label="轨迹查询" name="name2">
        <guiji :vipData="vipData" :userId="userId" @afterSave="queryUserVipInfo"></guiji>
      </TabPane>
      <TabPane label="船队扩容" name="name3">
        <ship :userId="userId"></ship>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import Vip from "@/components/userManage/Vip";
import Guiji from "@/components/userManage/NewGuiji";
import Ship from "@/components/userManage/Ship";

export default {
  components: {Vip, Guiji, Ship},
  data() {
    return {
      userId: null,
      vipData: {}
    }
  },
  methods: {
    setId(id) {
      this.userId = id;
      this.queryUserVipInfo();
    },
    async queryUserVipInfo() {
      let res = await $api.seachart.request("queryUserVipInfo", {
        id: this.userId
      });
      if (res.code === 1) {
        this.vipData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    }
  }
}
</script>
<style>

</style>